import { useEffect, useState } from "react";
import { Fab, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useTenant } from "../contexts/TenantContext";

const SHOW_AFTER_PX = 320;

const ScrollToTopButton = () => {
  const { displayConfig } = useTenant();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsVisible(window.scrollY > SHOW_AFTER_PX);

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({
    top: 0,
    behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
  });

  return (
    <Zoom in={isVisible}>
      <Fab
        onClick={scrollToTop}
        aria-label="Vissza az oldal tetejére"
        size="medium"
        sx={{
          position: "fixed",
          bottom: { xs: 16, sm: 24 },
          right: { xs: 16, sm: 24 },
          zIndex: theme => theme.zIndex.appBar - 1,
          backgroundColor: displayConfig?.buttonColor,
          color: displayConfig?.buttonTextColor,
          "&:hover": {
            backgroundColor: `color-mix(in srgb, ${displayConfig?.buttonColor} 85%, black)`,
          },
        }}>
        <KeyboardArrowUpIcon />
      </Fab>
    </Zoom>
  );
}

export default ScrollToTopButton;
